import React from 'react'

import Immutable from 'immutable'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

import placeholderSrc from 'media/images/recipe-placeholder.png'

import OrderRecipe from '../../../../../../AccountComponents/OrderRecipe'

import css from './OrderRecipeBox.css'

const OrderRecipeBox = ({ recipes, orderState, maxNumRecipes }) => {
  const maxRecipes =
    ['confirmed', 'dispatched'].indexOf(orderState) > -1 ? recipes.size : maxNumRecipes
  const recipesRendered = []
  for (let i = 0; i < maxRecipes; i++) {
    const recipeId = recipes.getIn([i, 'id'], null)
    const quantity = recipes.getIn([i, 'quantity'], 0)
    recipesRendered.push(
      <OrderRecipe
        recipeImage={recipeId ? recipes.getIn([i, 'image'], placeholderSrc) : ''}
        recipeTitle={recipes.getIn([i, 'title'], '')}
        key={recipeId || i}
        portions={recipeId ? `${quantity} portions` : ''}
      />,
    )
  }

  return <div className={css.horizontalScrollWrapper}>{recipesRendered}</div>
}

OrderRecipeBox.propTypes = {
  recipes: ImmutablePropTypes.listOf(
    ImmutablePropTypes.contains({
      recipeImage: PropTypes.string,
      recipeTitle: PropTypes.string,
    }),
  ),
  orderState: PropTypes.string,
  maxNumRecipes: PropTypes.number,
}

OrderRecipeBox.defaultProps = {
  recipes: Immutable.List([]),
  orderState: '',
  maxNumRecipes: 4,
}

export default OrderRecipeBox
